import { Directive, ElementRef, Renderer2, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[appRequiredLabel]'
})
export class RequiredLabelDirective implements AfterViewInit {

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit(): void {
    // Crear el span con el texto " (Obligatorio)"
    const span = this.renderer.createElement('span');
    const text = this.renderer.createText(' (Obligatorio)');
    
    this.renderer.appendChild(span, text);
    this.renderer.setStyle(span, 'color', 'red');
    this.renderer.setStyle(span, 'font-weight', 'bold');
    
    // Agregar el span al label
    this.renderer.appendChild(this.el.nativeElement, span);
  }
}
